import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/specsReportPrintV2.css' // ✅ PHASE 3: Print styles for V2 report
import { initSentry } from './lib/sentry'

// Initialize Sentry for error tracking
initSentry();

// Initialize React app with enhanced Phase 1 optimizations
createRoot(document.getElementById("root")!).render(<App />);
